import { type MouseEvent, type ReactNode, useEffect } from 'react';
import classNames from 'classnames';

import { trackChatbotTooltipClose, trackChatbotTooltipView } from '@jsmdg/tracking';
import styles from './ChatBotHelpTooltip.module.scss';

type ChatBotHelpTooltipProps = {
    readonly isMydays: boolean;
    readonly tooltipId: string;
    readonly closeLabel: string;
    readonly emoji: ReactNode;
    readonly children: ReactNode;
    readonly bottomShiftPx: number;
    readonly onClose: () => void;
};

const ChatBotHelpTooltip = ({
    bottomShiftPx,
    children,
    closeLabel,
    emoji,
    isMydays,
    onClose,
    tooltipId,
}: ChatBotHelpTooltipProps): JSX.Element => {
    useEffect(() => {
        trackChatbotTooltipView();
    }, []);

    const onCloseClick = (event: MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        trackChatbotTooltipClose();
        onClose();
    };

    return (
        <div
            className={classNames(styles.root, 'p-1x pr-3x', { [styles.rootMydays]: isMydays })}
            role="tooltip"
            style={{ bottom: `calc(5.8rem + ${bottomShiftPx}px)` }}
            id={tooltipId}
        >
            <button
                type="button"
                className={styles.close}
                aria-label={closeLabel}
                onClick={onCloseClick}
            >
                ×
            </button>
            <p className={styles.text}>
                <span className={classNames(styles.emoji, 'pr-0-5x')} aria-hidden="true">
                    {emoji}
                </span>
                {children}
            </p>
        </div>
    );
};

export { ChatBotHelpTooltip };
